import { proxy } from 'valtio'
import { useQuery } from 'react-query'
import { useMemo } from 'react'
import { CommonApi, ApplicationCertificateTypeProgramTypeResponse, ApplicationResponse } from '../../generated'
import { apiConfig } from '../apiConfig'
import { ProgramType, convertProgramType } from '../ProgramType'

export const applicationCertificateTypeProgramTypeStore = proxy<{
  items: ApplicationCertificateTypeProgramTypeResponse[]
}>({
  items: [],
})

const api = new CommonApi(apiConfig)

export async function loadApplicationCertificateTypeProgramTypes() {
  const result = await api.getApplicationCertificateTypeProgramTypes()
  applicationCertificateTypeProgramTypeStore.items = result
  return result
}

export function useApplicationCertificateTypeProgramTypes() {
  return useQuery(
    'application-certificate-type-program-types',
    loadApplicationCertificateTypeProgramTypes
  )
}

export function getApplicationCertificateTypesByProgramType(
  programType: ProgramType
): ApplicationCertificateTypeProgramTypeResponse[] {
  const list = applicationCertificateTypeProgramTypeStore.items
  const result = list.filter((item) => {
    if (item.programType === null || item.programType === undefined) {
      console.warn('Program type is null or undefined for item', item)
      return false
    }
    const itemProgramType = convertProgramType(item.programType)
    const match = itemProgramType === programType
    return match
  })
  return result
}

export function useApplicationCertificateTypesByProgramType(programType: ProgramType): ApplicationCertificateTypeProgramTypeResponse[] {
  return getApplicationCertificateTypesByProgramType(programType)
}

export function useApplicationCertificateTypesByApplication(application: ApplicationResponse | undefined) {
  const programType = convertProgramType(application?.program)
  return useApplicationCertificateTypesByProgramType(programType)
}

